import React, {useEffect, useState} from 'react';
import {
    CardBody, Col,Form, FormGroup, Input, Label, Row,
} from 'reactstrap';

import {
    ButtonClean,
    ButtonSearch,
} from "../../../components/buttons/buttonsActions";
import Switch from "react-bootstrap-switch";
import {categoryPromotionProvider} from "../../../providers/categoryPromotionProvider";
import {useForm} from "react-hook-form";
import {FL_CAT_PROM, FL_CODE, FL_COUPON, FL_STATUS} from "../../../components/i18n/formLabels";
import {PH_SEARCH_CODE, PH_SEARCH_COUPON} from "../../../components/i18n/placeHolders";
import SelectGeneric from "../../../components/select/selectGeneric";
import {setFilter} from "../../../redux/actions/generalActions/listActions";
import {connect} from "react-redux";

const PromotionFilters = (props) => {
    const { filter } = props.listProps
    const { app } = props.mainProps

    const fbDataBaseId = app?.fbDataBase?.id
    const [status, setStatus] = useState( filter?.item?.status ?? true);
    const [preferent, setPreferent] = useState(filter?.item?.topPreference ?? null);
    const [categoryPromotionId, setCategoryPromotionId] = useState(filter?.item?.categoryPromotion?.id || null);
    const [onlyRegistered, setOnlyRegistered] = useState(true);

    useEffect(() => {
    }, []);

    const {register, handleSubmit, reset} = useForm({
        defaultValues:{
            code: filter?.item?.code,
            coupon: filter?.item?.coupon
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase : {  id : fbDataBaseId },
            onlyRegistered : onlyRegistered ? onlyRegistered : null,
            item : {
                code: data.code,
                coupon: data.coupon,
            }
        }

        if (status !== undefined && status !== null) {
            dataFilter.item.status = status;
        }

        if (preferent !== undefined && preferent !== null) {
            dataFilter.item.topPreference = preferent;
        }

        if (categoryPromotionId !== undefined && categoryPromotionId !== null) {
            dataFilter.item.categoryPromotion = {id: categoryPromotionId};
        }

        props.setFilter(dataFilter);
    };

    const cleanFields = () => {
        const tmpFilter = JSON.parse(JSON.stringify(filter))

        setStatus(null);
        setOnlyRegistered(null);
        setPreferent(null);
        setCategoryPromotionId(null);
        reset({
            code: '',
            coupon: ''
        });

        if(tmpFilter && tmpFilter.item){
            delete tmpFilter.onlyRegistered;
            delete tmpFilter.item.code;
            delete tmpFilter.item.coupon;
            delete tmpFilter.item.status;
            delete tmpFilter.item?.categoryPromotion?.id;
        }
        props.setFilter(tmpFilter);
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>{FL_CAT_PROM}</Label>
                            <SelectGeneric
                                initialValue={categoryPromotionId}
                                setExternalValue={value => setCategoryPromotionId(value)}
                                provider={categoryPromotionProvider}
                                fbDataBaseId = { fbDataBaseId }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{FL_CODE}</Label>
                            <Input type="text" name="code"
                                   placeholder={PH_SEARCH_CODE}
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{FL_COUPON}</Label>
                            <Input type="text" name="coupon"
                                   placeholder={PH_SEARCH_COUPON}
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{FL_STATUS}</Label>
                            <br/>
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    value={status}
                                    innerRef={register}
                                    onChange={_ => setStatus(!status)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>Solo en app</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={onlyRegistered}
                                onChange={ () => setOnlyRegistered(!onlyRegistered) }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(PromotionFilters)
